import { IsNotEmpty } from "class-validator";
export class AssetCodeDto {
    assetCode: string;
    tubCode: string;
    codeType: string;
}